/**
 * Defines actions related to authorize feature.
 */

import * as types from 'constants/ActionTypes';

export const getAccessTokenAction = (code, state) => ({
  type: types.OKTA_TOKEN_REQUESTED,
  code,
  state,
});

export const getNewAccessTokenAction = (isNewUserCreated, subRoute) => ({
  type: types.OKTA_NEW_TOKEN_REQUESTED,
  isNewUserCreated,
  subRoute,
});

export const closeContainerToastMessage = () => ({
  type: types.CLOSE_CONTAINER_TOAST,
});

export const openContainerToastMessage = () => ({
  type: types.SHOW_CONTAINER_TOAST,
});

export const resetTimerAction = (reset) => ({
  type: types.RESET_TIMER,
  reset,
});

export const addUserInAMP = (userName, subRoute) => ({
  type: types.CREATE_USER_IN_AMP,
  userName,
  subRoute,
});

export const getUserOnboardingStatus = () => ({
  type: types.GET_USER_ONBOARDING_STATUS,
});

export const setAutoProvisionFlag = (autoProvision) => ({
  type: types.SET_AUTOPROVISION,
  autoProvision,
});

export const setAutoProvisionStatus = (status) => ({
  type: types.AUTO_PROVISION_STATUS,
  status,
});

export const setAuthorize = () => ({
  type: types.OKTA_TOKEN_RESPONDED,
});

export const getCustomAccessToken = (impersonationGuid) => ({
  type: types.GET_CUSTOM_TOKEN,
  impersonationGuid,
});

export const validateUserImpersonation = (impersonationGuid) => ({
  type: types.VALIDATE_USER_IMPERSONATION,
  impersonationGuid,
});

export const expireGuid = () => ({
  type: types.EXPIRE_GUID,
});

export const setShowReloadDialog = (showReloadDialog) => ({
  type: types.SET_SHOW_RELOAD_DIALOG,
  showReloadDialog,
});

export const setSignOutDisabled = (isDisabled) => ({
  type: types.SET_SIGN_OUT_DISABLED,
  payload: isDisabled,
});

/** Set when auth token is SHARE (guest). Kept in Redux so selectors stay pure. #genai */
export const setIsShareToken = (isShareToken) => ({
  type: types.SET_IS_SHARE_TOKEN,
  payload: Boolean(isShareToken),
});
